import { render } from "./LinkContactToCompany.vue?vue&type=template&id=0e2a1b99&scoped=true"
import script from "./LinkContactToCompany.vue?vue&type=script&lang=js"
export * from "./LinkContactToCompany.vue?vue&type=script&lang=js"

import "./LinkContactToCompany.vue?vue&type=style&index=0&id=0e2a1b99&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2a1b99"]])

export default __exports__